import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { loginPathFor } from '../lib/loginRedirect';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // The login URL carries the page being asked for (?redirectTo=...), so a
    // cold visit to a protected URL deep-links back after sign-in — and this
    // redirect can race the axios 401 handler's without stripping the param.
    return <Navigate to={loginPathFor(location.pathname + location.search)} replace />;
  }

  return <>{children}</>;
}
